import React, { useState, useMemo, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Modal,
  Paper,
  TextField,
  Typography
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import SalesOrderInvoice from 'components/Invoices/SalesOrderInvoice';

const InvoicesDisplay = (props) => {

  const printRef = useRef();

  const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
  const [invoiceOption, setinvoiceOption] = useState({});

  const SOInvoiceOptions = useMemo(() => {
    const initialSOInvoices = [];

    for ( let i = 0; i < props.salesOrders.length; i++ ) {
      const salesOrder = props.salesOrders[i];
      for ( let j = 0; j < salesOrder.payments.length; j++ ) {
        initialSOInvoices.push({
          salesOrderId: salesOrder.id,
          displayId: salesOrder.payments[j].displayId
        });
      }
    }

    return initialSOInvoices;

  }, [props.salesOrders]);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Sales Order Invoice"
  });

  const renderInvoice = () => {

    // For Sales Orders.
    const salesOrderInfo = props.salesOrders.find(salesOrder => salesOrder.id === invoiceOption.salesOrderId);
    const paymentInfo = salesOrderInfo.payments.find(payment => payment.displayId === invoiceOption.displayId);
    const customerInfo = props.customers.find(customer => customer.id === salesOrderInfo.customerId);
    const products = salesOrderInfo.products.map(salesOrderProduct => {
      const productInfo = props.products.find(product => product.id === salesOrderProduct.productId);
      return {
        name: productInfo ? productInfo.name : "",
        company: productInfo ? productInfo.company : "",
        ...salesOrderProduct
      }
    });
    const SOInvoiceInfo = {
      displayId: paymentInfo.displayId,
      customerName: customerInfo ? customerInfo.name : "",
      customerPhone: customerInfo ? customerInfo.phone: "",
      paymentDate: paymentInfo.createdAt,
      subTotal: paymentInfo.amount - paymentInfo.amountVat,
      taxTotal: paymentInfo.amountVat,
      currentAmount: paymentInfo.amount,
      grandTotal: salesOrderInfo.total,
      products: products,
      payments: salesOrderInfo.payments,
      status: salesOrderInfo.status
    };

    return (
      <SalesOrderInvoice
        ref={printRef}
        info={SOInvoiceInfo}
        user={props.user}
      />
    )
  };
  
  const handleInvoiceModalOpen = (option) => {
    setinvoiceOption(option);
    setOpenInvoiceModal(true);
  };

  const handleInvoiceModalClose = () => {
    setinvoiceOption({});
    setOpenInvoiceModal(false);
  };

  return (
    <React.Fragment>
      <Box style={{ minHeight: 180 }}>
        <Typography
          style={{ marginTop: 8, marginBottom: 4 }}
          color="textPrimary"
          variant="h5"
        >
          Invoice Printing
        </Typography>
        <Divider />
        <Grid
          container
          justify='center'
          spacing={3}
          style={{ textAlign: 'center' }}
        >
          <Grid
            item
            md={3}
            xs={12}
          >
            <Typography
              style={{ marginTop: 16, marginBottom: 8 }}
              color="textPrimary"
              variant="body1"
            >
              Print Sales Order Invoice
            </Typography>
            <Autocomplete
              onChange={(event, newValue) => {
                if(newValue) handleInvoiceModalOpen(newValue);
              }}
              id="free-solo-dialog-demo"
              options={SOInvoiceOptions}
              getOptionSelected={(option, value) => option.displayId === value.displayId}
              getOptionLabel={(option) => option.displayId}
              style={{ width: 360 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search Sales Order Invoice.."
                  variant="outlined"
                  helperText="Please select the Sales Order Invoice to be printed"
                />
              )}
              value={null}
            />
          </Grid>
        </Grid>
      </Box>
      { openInvoiceModal ?
        <Modal open={openInvoiceModal}>
          <Card>
            <CardHeader
              subheader="Please Review The Invoice"
              title="Print Invoice"
            />
            <Divider />
            <CardContent>
              <Box>
                <Paper
                  style={{
                    overflow: 'auto',
                    maxHeight: 469
                  }}
                >
                  {renderInvoice()}
                </Paper>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: '1%'
                  }}
                >
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handlePrint}
                  >
                    Print Invoice
                  </Button>
                  <Button sx={{ mx: 1 }} onClick={handleInvoiceModalClose}>
                    Close
                  </Button>
                </Box>
              </Box>
            </CardContent>
            <Divider/>
          </Card>
        </Modal>
      : null }
    </React.Fragment>
  )
};

export default InvoicesDisplay;